import React from 'react';
import { connect } from 'react-redux';
import { Modal, Form, message, InputNumber } from 'antd';
import * as actionTypes from '../../redux/actions/master/actionTypes';
import { updateSingleBetCommission } from '../../redux/actions/master/updateMaster';

const layout = {
    labelCol: { span: 10 },
    wrapperCol: { span: 24 },
};

class UpdateSingleBetCommissionModal extends React.Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }
    onFinish = async (values) => {
        await this.props.onUpdate({
            id:this.props.master?.id,
            singleBetCommissionId:this.props.master?.singleBetCommission?.id,
            betCommission:values.betCommission,
            winCommission:this.props.master?.singleBetCommission?.winCommission,
            highBetCommission:values.highBetCommission,
            highWinCommission:this.props.master?.singleBetCommission?.highWinCommission
        });
        if (this.props.error) {
            message.error(this.props.error);
        }
        if (this.props.message) {
            message.success(this.props.message);
        }
        this.form.current.resetFields();
        this.props.onClose();
    }
    onFinishFailed = (errors) => {
        console.log(errors)
    }
    handleCancel = () => {
        this.props.onClose();
    }
    render() {
        return (
            <Modal
                title="Update Single Bet Commission"
                key={this.props.master?.id}
                centered
                visible={this.props.visible}
                okButtonProps={{ form: 'update-sbc-form', key: 'submit', htmlType: 'submit' }}
                confirmLoading={this.props.loading}
                onCancel={this.handleCancel}
                okText="Save"
                loading={this.props.loading}
            >
                <Form
                {...layout}
                    ref={this.form}
                    style={{ margin: 25 }}
                    id="update-sbc-form"
                    name="basic"
                    initialValues={{
                        betCommission:this.props.master?.singleBetCommission?.betCommission,
                        highBetCommission:this.props.master?.singleBetCommission?.highBetCommission,
                    }}
                    onFinish={this.onFinish}
                    onFinishFailed={this.onFinishFailed}
                >
                    <Form.Item
                        name="betCommission"
                        label="Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                    <Form.Item
                        name="highBetCommission"
                        label="High Commission"
                        rules={[
                            {
                                required: true,
                                message: 'Require!',
                            }
                        ]}
                        hasFeedback
                    >
                        <InputNumber  style={{width:150}}/>
                    </Form.Item>
                </Form>
            </Modal>
        );
    }
}

const mapStateToProps = state => ({
    visible: state.master.updateSingleBetCommissionVisible,
    loading: state.master.loading,
    error: state.master.error,
    message: state.master.message,
    master:state.master.one
})

const mapDispatchToProps = dispatch => ({
    onUpdate: (obj) => dispatch(updateSingleBetCommission(obj)),
    onClose: () => dispatch({
        type:actionTypes.TOGGLE_SINGLE_BET_COMMISSION_UPDATE
    }),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateSingleBetCommissionModal);